import { Component, Input, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  MAT_NATIVE_DATE_FORMATS,
  MatNativeDateModule,
  NativeDateAdapter,
  DateAdapter,
} from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';


// 1. El adaptador minimalista (Solo altera cómo se pinta la fecha)
@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
}

@Component({
  selector: 'app-input-general-calendar',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    TranslateModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    // requerido explícitamente: dentro de un MatDialog el overlay del calendario
    // no hereda MAT_DATE_FORMATS desde el import de MatNativeDateModule.
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
  ],
  templateUrl: './input-general-calendar.component.html',
})
export class InputGeneralCalendarComponent {
  @Input() formControlGeneral: FormControl | AbstractControl | null = new FormControl();
  @Input() placeholder = '';
  @Input() label = '';
  @Input() min: null | Date = null;

  get getInputGeneral(): FormControl {
    return this.formControlGeneral as FormControl;
  }

  isRequired(control: AbstractControl | null): boolean {
    return !!control?.hasValidator?.(Validators.required);
  }
}